import React from 'react';

const HandShake: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9222 9.15882C18.9221 9.15886 18.9222 9.15879 18.9222 9.15882L11.4365 16.6444C12.4404 17.4564 13.6971 17.9052 15.0002 17.9052C16.5027 17.9052 17.9437 17.3085 19.0064 16.2462C19.0064 16.2462 19.0063 16.2462 19.0064 16.2462L23.3335 11.9191L24.7477 13.3333L20.4206 17.6604C18.9829 19.0977 17.0331 19.9052 15.0002 19.9052C12.9672 19.9052 11.0175 19.0978 9.57982 17.6605L8.58594 16.6666L17.508 7.74452C19.9059 5.34728 23.1578 4.00049 26.5485 4.00049C29.9391 4.00049 33.191 5.34719 35.5888 7.74443C37.6024 9.75821 38.8865 12.3865 39.2372 15.2127C39.588 18.0388 38.9855 20.9011 37.5254 23.346L37.0126 24.2046L35.2955 23.1791L35.8083 22.3205C37.0401 20.2579 37.5484 17.8432 37.2525 15.459C36.9566 13.0748 35.8734 10.8576 34.1747 9.1587C32.1519 7.1365 29.4087 6.00049 26.5485 6.00049C23.6882 6.00049 20.945 7.13661 18.9222 9.15882Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3421 5.9912L13.3421 5.99994C10.5194 6.02463 7.81972 7.15894 5.82647 9.15777L5.11842 8.45169L5.82557 9.15866C3.8033 11.1815 2.66724 13.9247 2.66724 16.785C2.66724 19.6453 3.8033 22.3885 5.82557 24.4113L15.3021 33.8879C16.1379 34.7238 17.1302 35.3869 18.2222 35.8393C19.3142 36.2917 20.4847 36.5245 21.6667 36.5245C22.8487 36.5245 24.0192 36.2917 25.1112 35.8393C26.2032 35.3869 27.1955 34.7238 28.0312 33.8879L30.7578 31.1613C30.7579 31.1613 30.7578 31.1614 30.7578 31.1613C31.5076 30.4112 31.929 29.3939 31.929 28.3333C31.929 27.2727 31.5077 26.2555 30.7579 25.5054C30.7579 25.5054 30.758 25.5055 30.7579 25.5054L24.0292 18.7766L25.4434 17.3624L32.1721 24.0912C33.297 25.2164 33.929 26.7423 33.929 28.3333C33.929 29.9243 33.2971 31.4501 32.1723 32.5753L29.4455 35.302C29.4455 35.302 29.4456 35.302 29.4455 35.302C28.4241 36.3236 27.2113 37.1341 25.8767 37.687C24.542 38.2399 23.1114 38.5245 21.6667 38.5245C20.222 38.5245 18.7915 38.2399 17.4568 37.687C16.1221 37.1341 14.9094 36.3237 13.8879 35.3021C13.8879 35.3021 13.888 35.3021 13.8879 35.3021L4.41127 25.8254C2.01403 23.4276 0.667236 20.1756 0.667236 16.785C0.667236 13.3943 2.01394 10.1425 4.41117 7.74463C6.7753 5.37437 9.97701 4.02929 13.3246 4.00002L14.3246 3.99127L14.3421 5.9912Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.8737 25.4911L31.3588 31.9744L29.9447 33.3888L23.4597 26.9055L24.8737 25.4911Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5121 29.8512L26.5621 35.9012L25.1479 37.3154L19.0979 31.2654L20.5121 29.8512Z"
      />
    </svg>
  );
};

export default HandShake;
